import { useRouter } from 'vue-router'
import { useGame, useGamesStore } from '@nsftx/seven-client-retail-vue-sgp'
import { isAppShortcut, useShortcut } from '@nsftx/seven-nxg-retail-vue-sdk'

export const useOpenGameShortcut = () => {
  const router = useRouter()

  useShortcut('OPEN_GAME', (shortcut) => {
    const gameId = isAppShortcut(shortcut) ? shortcut.subject?.value : null
    if (!gameId) {
      return
    }

    const { getGameLinkByGameId } = useGamesStore()
    const gameLink = getGameLinkByGameId(gameId)
    if (!gameLink) {
      return
    }

    const { gameDisplayId } = useGame(gameLink)
    if (!gameDisplayId.value) {
      return
    }

    router.push({ name: 'game', params: { gameId: gameDisplayId.value } })
  })
}
